export const nextTickControl = (self, windowPopupElement) => {
   if (!windowPopupElement.closed) {
      self.$nextTick(() => {
         self.funcPost3DRequest(windowPopupElement);
      });
   }
};
